import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown, Menu } from 'antd'
import * as R from 'ramda'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Menu as SemanticMenu } from 'semantic-ui-react'
import styled from 'styled-components'
import { getUserMe } from '../../api/async/users/index'
import Login from '../../containers/Login'
import Signup from '../../containers/Signup'
import { localStorageSafe } from '../../utils/index'
import checkRunStatus from './imgs/check-run-status.png'
import collectionsIcon from './imgs/collections.png'
import confirmIcon from './imgs/confirm-payment.png'
import loginIcon from './imgs/login.png'
import logoMobile from './imgs/logo-mobile.png'
import logo from './imgs/logo.png'
import logoutIcon from './imgs/logout.png'
import myOrderIcon from './imgs/my-order.png'
import myRacesIcon from './imgs/my-races.png'
import racesIcon from './imgs/races.png'
import signupIcon from './imgs/signup.png'
import submitIcon from './imgs/submit-run.png'
import submitRunLineIcon from './imgs/submit-run-line.png'
import aboutUsIcon from './imgs/about-us.png'

const StyledLink = styled(Link)`
  color: #00355f;
  font-weight: normal;
`

const StyledALink = styled.a`
  color: #00355f;
  font-weight: normal;
`

const StyledMenuItem = styled(Menu.Item)`
  font-size: 18px;
`

class Nav extends React.Component {
  state = {
    isLogin: localStorageSafe && localStorage.getItem('run-24-hrs-token'),
    loginOpen: false,
    signUpOpen: false,
    user: {}
  }

  componentDidMount() {
    getUserMe().then(
      res => R.path(['email'], res.data) && this.setState({ user: res.data })
    )
  }

  setLogin = () => this.setState({ isLogin: true })
  setLogout = () => this.setState({ isLogin: false })

  toggleSignup = state => this.setState({ signUpOpen: state })
  toggleLogin = state => this.setState({ loginOpen: state })

  menu = isLogin => (
    <Menu>
      <StyledMenuItem key="0">
        <StyledLink to="/races/">
          <img style={{ height: 30 }} src={racesIcon} />
          <span style={{ paddingLeft: 5 }}>งานวิ่ง</span>
        </StyledLink>
      </StyledMenuItem>
      <StyledMenuItem key="1">
        <StyledLink to="/events/">
          <img style={{ height: 30 }} src={collectionsIcon} />
          <span style={{ paddingLeft: 5 }}>ของสะสม</span>
        </StyledLink>
      </StyledMenuItem>
      {isLogin && (
        <StyledMenuItem key="2">
          <StyledLink to="/confirm-payment">
            <img style={{ height: 30 }} src={confirmIcon} />
            <span style={{ paddingLeft: 5 }}>แจ้งโอนเงิน</span>
          </StyledLink>
        </StyledMenuItem>
      )}
      {isLogin && (
        <StyledMenuItem key="3">
          <StyledLink to="/submit-run">
            <img style={{ height: 30 }} src={submitIcon} />
            <span style={{ paddingLeft: 5 }}>แจ้งผลวิ่ง/เดิน</span>
          </StyledLink>
        </StyledMenuItem>
      )}
      {isLogin && !R.path(['user', 'line_user_id'], this.state) && (
        <StyledMenuItem key="9">
          <StyledALink href="https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653776815&redirect_uri=https://run24hrs.com/me&state=4879387898abcde&scope=openid%20profile&nonce=09876xyz&bot_prompt=aggressive">
            <img style={{ height: 30 }} src={submitRunLineIcon} />
            <span style={{ paddingLeft: 5 }}>แจ้งผลวิ่ง/เดิน (Line)</span>
          </StyledALink>
        </StyledMenuItem>
      )}
      {isLogin && (
        <StyledMenuItem key="4">
          <StyledLink to="/run-status">
            <img style={{ height: 30 }} src={checkRunStatus} />
            <span style={{ paddingLeft: 5 }}>ตรวจสอบสถานะผลวิ่ง</span>
          </StyledLink>
        </StyledMenuItem>
      )}
      {isLogin && (
        <StyledMenuItem key="5">
          <StyledLink to="/me/">
            <img style={{ height: 30 }} src={myRacesIcon} />
            <span style={{ paddingLeft: 5 }}>งานวิ่งของฉัน</span>
          </StyledLink>
        </StyledMenuItem>
      )}
      {isLogin && (
        <StyledMenuItem key="6">
          <StyledLink to="/my-order/">
            <img style={{ height: 30 }} src={myOrderIcon} />
            <span style={{ paddingLeft: 5 }}>คำสั่งซื้อของฉัน</span>
          </StyledLink>
        </StyledMenuItem>
      )}
      <StyledMenuItem key="8">
        <StyledALink
          href="https://news.run24hrs.com/%E0%B9%80%E0%B8%81%E0%B8%B5%E0%B9%88%E0%B8%A2%E0%B8%A7%E0%B8%81%E0%B8%B1%E0%B8%9A%E0%B9%80%E0%B8%A3%E0%B8%B2/"
          target="_blank"
        >
          <img style={{ height: 30 }} src={aboutUsIcon} />
          <span style={{ paddingLeft: 5 }}>เกี่ยวกับเรา</span>
        </StyledALink>
      </StyledMenuItem>
      {isLogin && (
        <StyledMenuItem key="7">
          <div
            onClick={() => {
              localStorage.clear()
              this.setLogout()
              this.props.history.push('/')
              setTimeout(() => window.location.reload(), 1000)
            }}
          >
            <img style={{ height: 30 }} src={logoutIcon} />
            <span style={{ paddingLeft: 5 }}>ออกจากระบบ</span>
          </div>
        </StyledMenuItem>
      )}

      {!isLogin && (
        <StyledMenuItem key="4" onClick={() => this.toggleLogin(true)}>
          <img style={{ height: 30 }} src={loginIcon} />
          <span style={{ paddingLeft: 5 }}>เข้าสู่ระบบ</span>
        </StyledMenuItem>
      )}
      {!isLogin && (
        <StyledMenuItem key="5" onClick={() => this.toggleSignup(true)}>
          <img style={{ height: 30 }} src={signupIcon} />
          <span style={{ paddingLeft: 5 }}>สมัครสมาชิก</span>
        </StyledMenuItem>
      )}
    </Menu>
  )

  render() {
    const { isLogin, loginOpen, signUpOpen } = this.state
    return (
      <React.Fragment>
        <div
          className="ui attached stackable menu"
          style={{ backgroundColor: '#fc0', color: '#00355f' }}
        >
          <div className="ui container">
            <SemanticMenu.Menu
              style={{ backgroundColor: '#fc0', border: 'none' }}
              className="mobile-not-show"
            >
              <Link to="/races">
                <img width="129" height="50" src={logo} />
              </Link>
            </SemanticMenu.Menu>
            <SemanticMenu.Menu position="right">
              <Dropdown
                overlay={this.menu(isLogin)}
                placement="bottomRight"
                trigger={['click']}
                style={{ width: 450 }}
              >
                <div>
                  <Link to="/races" className="show-only-mobile">
                    <img width="50" height="50" src={logoMobile} />
                  </Link>
                  {/* {isLogin && (
                    <div
                      style={{
                        float: 'right',
                        marginTop: 5,
                        marginLeft: 10,
                        width: '2.5em'
                      }}
                      className="mobile-not-show "
                    >
                      <div>
                        <img
                          className="ui image circular"
                          style={{ width: '2.5em' }}
                          src={R.path(['profile_picture'], this.state.user)}
                        />
                      </div>
                    </div>
                  )} */}
                  <div
                    style={{ float: 'right', marginTop: 10, marginLeft: 10 }}
                    className="mobile-not-show"
                  >
                    <span style={{ fontWeight: 'bold', fontSize: 'larger' }}>
                      Menu
                    </span>
                  </div>

                  <div
                    style={{ marginTop: 7, float: 'right' }}
                    className="mobile-mr-1e"
                  >
                    <FontAwesomeIcon icon={faBars} size="2x" />
                  </div>
                </div>
              </Dropdown>
            </SemanticMenu.Menu>
          </div>
        </div>
        <Login
          open={loginOpen}
          onClose={() => this.toggleLogin(false)}
          toggleSignup={() => this.toggleSignup(true)}
          setLogin={this.setLogin}
        />
        <Signup
          open={signUpOpen}
          onClose={() => this.toggleSignup(false)}
          setLogin={this.setLogin}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(Nav)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Nav/index.js